import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NewDepositPage } from '@/features/new-deposit/new-deposit-page.js';

const searchSchema = z.object({ draft: z.string().min(1).optional().catch(undefined) });

export const Route = createFileRoute('/_app/deposits/new')({
  validateSearch: searchSchema,
  component: NewDepositRoute,
});

function NewDepositRoute(): React.JSX.Element {
  const { draft } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <NewDepositPage
      draftId={draft}
      onDraftChange={(id) => void navigate({ search: id ? { draft: id } : {}, replace: true })}
    />
  );
}
